module.exports = __webpack_public_path__ + "static/img/f_first_03.0a5c8d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/f_first_03.png
// module id = 5nYM
// module chunks = 9